<template>
    <ul>
        <li :class="{expanded:item.expanded, collapsed:!item.expanded}" :key="item.title" v-for="item in filteredItems">
            <template v-if="expandOn === 'click' && item.items?.length">
                <ux-link @click.stop.prevent="toggle(item)" :class="item.class">
                    <flex-row center>
                        <flex-cell>
                            {{item.title}}
                        </flex-cell>
                        <flex-cell shrink v-if="displayCaret">
                            <ux-icon class="caret" icon="fa-angle-down" />
                        </flex-cell>
                    </flex-row>
                </ux-link>
            </template>
            <template v-else>
                <ux-link :class="item.class" v-if="item.type === 'url'" :target="item.target" :href="item.href || item.url">
                    {{item.title}}
                </ux-link>
                <ux-link :class="item.class" v-else-if="item.type === 'route'" :to="{name:item.route}">
                    {{item.title}}
                </ux-link>
            </template>
            <template v-if="item.items && item.items.length">
                <menulist :expandOn="expandOn" :items="item.items" :displayCaret="displayCaret" :isolate="isolate" :depth="actualDepth-1" />
            </template>
        </li>
    </ul>
</template>
<script>
export default {
    name: 'menulist',
    props: {
        items: {
            type: Array,
            default () {
                return [];
            }
        },
        depth: {
            type: Number,
            default: 0,
        },
        expandOn: {
            type: String,
            default: 'none',
        },
        isolate:{
            type:Boolean,
            default:true,
        },
        collapseOnRouteChange:{
            type:Boolean,
            default:true,
        },
        displayCaret:{
            type:Boolean,
        default:true,
        }
    },
    mounted() {
        this.mounted = true;
        this.addRouteChangeListeners();
    },
    beforeUnmount() {
        this.mounted = false;
        this.removeRouteChangeListeners();
        this.removeListeners();
    },
    computed: {
        actualDepth() {
            const d = this.depth;
            if (isNaN(d) || !parseInt(d)) {
                return 0;
            }
            return Math.max(d, 0);
        },
        filteredItems() {
            const self = this;

            let filtered = self.tree.filter(function(item) {

                // If the menu item has advanced contextual
                // visibility configurated we need to check
                // if it should be visible or not
                if(item.advancedOptions) {
                    if(self.$sdk.utils.checkContextVisibility) {
                        const matchesConfiguration = self.$sdk.utils.checkContextVisibility(item.contextVisibility);
                        if(!matchesConfiguration) {
                            return false;
                        }
                    }
                }


                if(item.disabled) {
                    return false;
                }

                return true;
            })


            if (this.actualDepth === 1) {
                filtered = filtered.map(function(i) {
                    return {
                        ...i,
                        items: [],
                    }
                })
            }


            return filtered;
        },
        // expandedItem: {
        //     get() {
        //         return this.currentExpandedItem;
        //     },
        //     set(v) {
        //         if (this.currentExpandedItem) {
        //             this.currentExpandedItem.expanded = false;
        //             this.currentExpandedItem.collapsed = true;
        //         }

        //         this.currentExpandedItem = v;
        //         if (this.currentExpandedItem) {
        //             this.currentExpandedItem.expanded = true;
        //             this.currentExpandedItem.collapsed = false;
        //             this.addListeners();
        //         } else {
        //             this.removeListeners();
        //         }
        //     }
        // }
    },
    data() {
        return {
            currentExpandedItems:[],
            // currentExpandedItem: null,
            tree: JSON.parse(JSON.stringify(this.items)),
        }
    },
    methods: {
        globalClick($event) {
            // this.expandedItem = null;
            this.currentExpandedItems = []
        },
        routeChanged() {

            if(this.collapseOnRouteChange) {
                this.collapseAll();
            }
        },
        addRouteChangeListeners() {
            this.$sdk.addEventListener('route:change', this.routeChanged);
        },
        removeRouteChangeListeners() {
            this.$sdk.removeEventListener('route:change', this.routeChanged);
        },
        addListeners() {
            
            const doco = this.$el?.ownerDocument;

            if (!doco) {
                return;
            }

            doco.body.addEventListener('click', this.globalClick);
        },
        removeListeners() {
            const doco = this.$el?.ownerDocument;

            if (!doco) {
                return;
            }

            doco.body.removeEventListener('click', this.globalClick);
        },
        expandItem(item) {
            item.expanded = true;
            this.currentExpandedItems.push(item);
        },
        collapseItem(item) {

            const index = this.currentExpandedItems.indexOf(item);
            if(index === -1) {
                return;
            }

            item.expanded = false;
            this.currentExpandedItems.splice(index, 1);
        },

            // expandedItem: {
        //     get() {
        //         return this.currentExpandedItem;
        //     },
        //     set(v) {
        //         if (this.currentExpandedItem) {
        //             this.currentExpandedItem.expanded = false;
        //             this.currentExpandedItem.collapsed = true;
        //         }

        //         this.currentExpandedItem = v;
        //         if (this.currentExpandedItem) {
        //             this.currentExpandedItem.expanded = true;
        //             this.currentExpandedItem.collapsed = false;
        //             this.addListeners();
        //         } else {
        //             this.removeListeners();
        //         }
        //     }
        // }
        // 
        // 
        // },
        collapseAll() {
            this.currentExpandedItems.forEach(function(item) {
                item.expanded = false;
            })
            this.currentExpandedItems = []

            if(this.currentExpandedItems.length) {
                this.addListeners();
            } else {
                this.removeListeners();
            } 
        },
        toggle(item) {
            const previouslyExpanded = item.expanded;

            if(this.isolate) {
                this.currentExpandedItems.forEach(function(item) {
                    item.expanded = false;
                })

                this.currentExpandedItems = []
            }

            const index = this.currentExpandedItems.indexOf(item);


            // It's not selected
            if(previouslyExpanded || index !== -1) {
                this.collapseItem(item)
            } else {
                this.expandItem(item)
            }

            if(this.currentExpandedItems.length) {
                this.addListeners();
            } else {
                this.removeListeners();
            }            
        },
    },
    watch: {
        items: {
            handler(items) {
                this.tree = JSON.parse(JSON.stringify(items));
            },
            deep: true
        }
    },
}
</script>

<style scoped lang="scss">

.ux-link .caret {
    transition: all 0.3s;
}

li.expanded > .ux-link .caret {
    transform:rotate(180deg);
}
    </style>}
